<script>
import '../../core/i18n';
import Cookies from 'js-cookie';
import Banner from './Banner.vue';
import Whatsapp from './Whatsapp.vue';
import Watermark from './Watermark.vue';
import Checkout from './Checkout/Checkout.vue';

export default {
  components: {
    Banner,
    Checkout,
    Whatsapp,
    Watermark,
  },

  mounted () {
    const {
      test,
      token,
      banner,
      whatsapp,
      checkouts,
      watermark,
      hasBanner,
    } = window.BulldeskSettings;

    this.test = test;
    this.whatsapp = whatsapp
    this.public_token = token;
    this.watermark = watermark,
    this.hasBanner = hasBanner || banner;
    this.checkouts = checkouts && ! Array.isArray(checkouts) ? [checkouts] : checkouts;

    this.setup();
  },

  data: () => ({
    test: '',
    show: false,
    submited: '',
    whatsapp: null,
    checkouts: null,
    hasBanner: false,
    public_token: '',
    watermark: null,
    showBanner: false,
  }),

  computed: {
    selected () {
      const {
        checkouts,
      } = this;

      return checkouts.find(({ hashid }) => hashid === this.submited);
    },
  },

  methods: {
    setup () {
      if (this.hasBanner) {
        this.loadBanner();
      }

      if (this.checkouts) {
        this.loadCheckouts();
      }
    },

    loadCheckouts () {
      document.querySelectorAll('[dir]').forEach((checkout) => {
        const hashid = checkout.attributes.dir.value;

        const data = this.checkouts.find((form) => form.hashid === hashid);

        if (! data) {
          return;
        }

        if (! data.inline) {
          checkout.onsubmit = (evt) => {
            evt.preventDefault();

            this.show = true;

            this.submited = hashid;
          };

          return;
        }

        const form = this.createNewCheckout(data);

        checkout.innerHTML = '';
        checkout.appendChild(form);
      });
    },

    createNewCheckout (data) {
      const checkout = document.createElement('bulldesk-checkout');

      checkout.checkout = data;
      checkout.test = this.test;
      checkout.publicToken = this.public_token;

      return checkout;
    },

    loadBanner () {
      /**
       * Get "deniedCookie" object of local storage
       */
      const deniedCookie = this.getLocalStorage('deniedCookie');

      if (deniedCookie && ! this.hasExpired(deniedCookie)) {
        return;
      }

      this.showBanner = true;
    },

    /**
     * Get value on local storage
     */
    getLocalStorage (key) {
      /**
       * Get 'bulldesk-settings' of the local storage
       */
      const settings = JSON.parse(window.localStorage.getItem('bulldesk-settings')) || {};

      /**
       * Return object of key
       */
      return settings[key];
    },

    /**
     * Set value on local storage
     */
    setLocalStorage (deniedCookie) {
      this.showBanner = false;

      const expiry = this.getExpiryDate();

      const value = {
        deniedCookie: {
          expiry,
          value: deniedCookie,
        },
      };

      window.localStorage.setItem('bulldesk-settings', JSON.stringify(value));

      if (deniedCookie) {
        Cookies.remove('bulldesk-analytics');

        window.BulldeskSettings.deniedCookie = true;
      }
    },

    getExpiryDate (deniedCookie) {
      const now = new Date().getTime();

      if (deniedCookie) {
        // 3 days is denied
        return now + 60 * 60 * 60 * 24 * 3;
      }

      /**
       * 60 days if allowed
       */
      return now + 60 * 60 * 60 * 24 * 180;
    },

    /**
     * Verify if date of value has expired;
     */
    hasExpired ({ expiry = 0 }) {
      const now = new Date();

      return now.getTime() > expiry;
    },
  },
};
</script>

<template>
  <div
    class="handle"
  >
    <Checkout
      :test="test"
      :checkout="selected"
      @close="show = false"
      v-if="show && selected"
      :public-token="public_token"
    />

    <Banner
      :show="showBanner"
      @close="setLocalStorage"
    />

    <Watermark
      v-if="watermark"
    />

    <Whatsapp
      :whatsapp="whatsapp"
      :token="public_token"
      v-if="whatsapp && whatsapp.config && whatsapp.config.enable"
    />
  </div>
</template>
